import { useState } from 'react';

const useToggle = (initialState = false) => {
  const [open, setOpen] = useState(initialState);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return {
    handleClose,
    handleOpen,
    open
  };
};

export default useToggle;
